import { ActionType, Action, visitState } from "../actions/types"

const initialVisitState: visitState = {
  visit: {
    id: "",
    visit: {},
    visitPurpose: ""
  }
}

const visitReducer = (
  state: visitState = initialVisitState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_VISIT:
      return {
        ...state,
        visit: action.payload
      }
    case ActionType.SET_VISIT_PURPOSE:
      return {
        ...state,
        visitPurpose: action.payload
      }
    default:
      return state
  }
}

export default visitReducer
